import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// used to create fake backend
import { fakeBackendProvider } from './_helpers';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { BasicAuthInterceptor, ErrorInterceptor } from './_helpers';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { TopHeaderComponent } from './top-header/top-header.component';
import { ContentRechargeComponent } from './content-recharge/content-recharge.component';
import { ContentSectionFeathureComponent } from './content-section-feathure/content-section-feathure.component';
import { ContentSectionMobileDownloadComponent } from './content-section-mobile-download/content-section-mobile-download.component';
import { FooterComponent } from './footer/footer.component';
import { PopmodelComponent } from './popmodel/popmodel.component';
import { ContentSectionRefererComponent } from './content-section-referer/content-section-referer.component';
import { FAQComponent } from './faq/faq.component';
import { ContactComponent } from './contact/contact.component';
import { SupportComponent } from './support/support.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ProfileComponent } from './profile/profile.component';
import { MyOrderComponent } from './my-order/my-order.component';
import { SecurePaymentComponent } from './secure-payment/secure-payment.component';
import { PlansComponent } from './plans/plans.component';
import { PageNotFoundComponent }   from './page-not-found/page-not-found.component';;
import { LoginPopupComponent } from './login-popup/login-popup.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { DaysComponent } from './jquery/days.component';
import { CommonLoginSectionComponent } from './common-login-section/common-login-section.component'
export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    dateInputFormat: 'DD-MM-YYYY'
  });
}
@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        BsDatepickerModule.forRoot()
       
    ],
    declarations: [
        AppComponent,
        HomeComponent,
        LoginComponent,
        PageNotFoundComponent,
        TopHeaderComponent,
        ContentRechargeComponent,
        ContentSectionFeathureComponent,
        ContentSectionMobileDownloadComponent,
        FooterComponent,
        PopmodelComponent,
        ContentSectionRefererComponent,
        FAQComponent,
        ContactComponent,
        SupportComponent,
        PrivacyPolicyComponent,
        TermsAndConditionsComponent,
        AboutUsComponent,
        ProfileComponent,
        MyOrderComponent,
        SecurePaymentComponent,
        DaysComponent,
        PlansComponent,
        
        LoginPopupComponent,
        
        CommonLoginSectionComponent    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        fakeBackendProvider,
        { provide: BsDatepickerConfig, useFactory: getDatepickerConfig }
        // provider used to create fake backend
        
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

